export const getUserTextKey = (user, userId, isRestoreReportsCell = false) => {
  if (user) {
    if (user.get('removed')) {
      return 'reports.table.removedUser';
    }
    if (user.get('gdprDeleted')) {
      return 'reports.table.gdprDeletedUser';
    }
    return 'fullName';
  }
  if (isRestoreReportsCell && !userId) {
    return 'reports.table.hubspotDeleted';
  }
  return 'reports.table.removedUser';
};
export const getUserFullName = user => {
  return !user || user.get('removed') || user.get('gdprDeleted') ? null : user.get('fullName');
};